import React, { Component } from 'react';


class SimpleInput extends Component {
  render() {

    const {
      value,
      onChange,
      placeholder,
    } = this.props;

    return (
      <div className='select-age-wrapper form-input'>
        <input
          className='form-control'
          value={value}
          onChange={(event) => {
            onChange(event.target.value)
          }}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

export default SimpleInput;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/SimpleInput.js